import { Sparkles } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { formatError } from "@/auth";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export function VarChips({ variables, onPick }) {
  return <div className="sr-vars">{variables.map((v) => <button key={v.key} type="button" title={v.label} onClick={() => onPick(`{${v.key}}`)} data-testid={`var-${v.key}`}>{`{${v.key}}`}</button>)}</div>;
}

function AiHelper({ onPick }) {
  const [instruction, setInstruction] = useState("");
  const [busy, setBusy] = useState(false);
  const [variants, setVariants] = useState([]);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/ai/email-draft", { instruction, context: "transition" }, { timeout: 120000 }); setVariants(data.variants); } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div className="sr-ai" data-testid="tpl-ai">
      <label>Rédiger avec l'IA<textarea rows={2} placeholder="Ex. : relancer un syndic qui n'a pas répondu après l'envoi de l'étude, ton chaleureux" value={instruction} onChange={(e) => setInstruction(e.target.value)} data-testid="tpl-ai-input" /></label>
      <button type="button" className="secondary-button" onClick={run} disabled={busy || instruction.trim().length < 3} data-testid="tpl-ai-run"><Sparkles size={15} />{busy ? "Génération…" : "Générer 3 propositions"}</button>
      {variants.length > 0 && <div className="sr-variants">{variants.map((v, i) => <button key={v.label} type="button" onClick={() => onPick(v)} data-testid={`tpl-ai-variant-${i}`}><strong>{v.label}</strong><span>{v.subject}</span><small>{v.body.slice(0, 140)}…</small></button>)}</div>}
    </div>
  );
}

export function TemplateEditor({ template, variables, onClose, onSaved }) {
  const [form, setForm] = useState({ name: template?.name || "", subject: template?.subject || "", body: template?.body || "" });
  const save = async () => {
    try {
      const { data } = template ? await api.put(`/email-templates/${template.id}`, form) : await api.post("/email-templates", form);
      toast.success("Modèle enregistré."); onSaved(data);
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="pj-dialog" data-testid="tpl-editor">
        <DialogTitle className="pj-dialog-title">{template ? "Modifier le modèle" : "Nouveau modèle d'e-mail"}</DialogTitle>
        <AiHelper onPick={(v) => setForm({ ...form, subject: v.subject, body: v.body, name: form.name || v.subject.slice(0, 60) })} />
        <label>Nom du modèle<input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="tpl-name" /></label>
        <label>Objet<input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="tpl-subject" /></label>
        <label>Message<textarea rows={12} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="tpl-body" /></label>
        <VarChips variables={variables} onPick={(v) => setForm({ ...form, body: `${form.body}${v}` })} />
        <button type="button" className="primary-button pj-self-start" onClick={save} disabled={!form.name || !form.subject || !form.body} data-testid="tpl-save">Enregistrer le modèle</button>
      </DialogContent>
    </Dialog>
  );
}
